export default __webpack_public_path__ + "static/assets/images/join-hex-right.ca9af69b3551a5fc90c0a0690c2ef55f.svg";